import {
    OrderForReturnDTO,
    OrderApiOrderGetOrderRequest,
    OrderApiOrderGetOrdersRequest,
    ReturnOrderHeader,
    OrderApiOrderGetOrderDeliveryInfoPOSTRequest,
    OrderDeliveryInfo,
    OrderApiOrderGetOrderByBarcodeRequest,
    OrderApiOrderSearchCustomersRequest,
    CustomerSearchItemPageInfo,
    BarcodeSearchResult,
} from 'returnCenter-api';
import { orderApi } from './api';
import { getLanguage } from './languageStore';

/**
 * Order service - handles order-related API calls
 * Maps to OrderController endpoints
 */
export const orderService = {
    /**
     * Get a single order by ID
     */
    getOrder: async (request: OrderApiOrderGetOrderRequest): Promise<OrderForReturnDTO> => {
        const response = await orderApi.orderGetOrder({ language: getLanguage(), ...request });
        return response.data;
    },

    /**
     * Get orders with search/filter
     */
    getOrders: async (
        request: OrderApiOrderGetOrdersRequest & { searchArticles?: boolean },
        signal?: AbortSignal,
    ): Promise<Array<ReturnOrderHeader>> => {
        const options = signal ? { signal } : {};
        const response = await orderApi.orderGetOrders({ language: getLanguage(), ...request }, options);
        return response.data;
    },

    /**
     * Get order delivery info for multiple orders
     */
    getOrderDeliveryInfo: async (
        payload: OrderApiOrderGetOrderDeliveryInfoPOSTRequest,
    ): Promise<Array<OrderDeliveryInfo>> => {
        const response = await orderApi.orderGetOrderDeliveryInfoPOST(payload);
        return response.data;
    },

    /**
     * Get order by barcode
     */
    getOrderByBarcode: async (request: OrderApiOrderGetOrderByBarcodeRequest): Promise<BarcodeSearchResult> => {
        const response = await orderApi.orderGetOrderByBarcode({ language: getLanguage(), ...request });
        return response.data;
    },

    /**
     * Search customers by name or code
     */
    searchCustomers: async (
        request: OrderApiOrderSearchCustomersRequest,
        signal?: AbortSignal,
    ): Promise<CustomerSearchItemPageInfo> => {
        const options = signal ? { signal } : {};
        const response = await orderApi.orderSearchCustomers(request, options);
        return response.data;
    },
};
